// extracted by mini-css-extract-plugin
export default {"button":"Hamburger_button__twafw","iconMenuClosed":"Hamburger_iconMenuClosed__3LvXb","iconMenuOpen":"Hamburger_iconMenuOpen__QP3Ns"};